import { type VariantAttribute, getVariantAttributeLabel } from "@swo/shared";
import { array as A } from "fp-ts";
import { pipe } from "fp-ts/lib/function";
import { labeledEq } from "./labeledEq";

export function computeTechSpecsAttributes(
  attributes: Array<VariantAttribute>,
  translations: {
    yesLabel: string;
    noLabel: string;
  },
  countryIsoCode: string,
): Array<{ label: string; valueLabel: string }> {
  const getVariantAttributeLabel_ = (attribute: VariantAttribute) =>
    getVariantAttributeLabel(attribute, translations, countryIsoCode);

  return pipe(
    attributes.flatMap(attribute => {
      const value = getVariantAttributeLabel_(attribute);

      return value
        ? [
            {
              label: attribute.label,
              valueLabel: value,
            },
          ]
        : [];
    }),
    A.uniq(labeledEq()),
  );
}
